SET_ALERT_BAR_CLOSED